import { useCallback } from 'react';
import { useAppDownloadModal } from './useAppDownloadModal';
import { bridge } from '../utils/bridge/bridge';
import { convertDeeplinkToWebLink } from '../utils/convertDeeplinkToWebLink/convertDeeplinkToWebLink';
import { useRootStackNavigation } from './useRootNavigation';
import { resolveScreenFromPath } from '../webRoutePaths';

export const useOpenDeeplink = () => {
  const { show: showAppDownloadModal } = useAppDownloadModal();
  const navigation = useRootStackNavigation();

  const openDeeplink = useCallback(
    (link: string) => {
      bridge.openDeeplink(link, {
        webCallback: async () => {
          const webLink = await convertDeeplinkToWebLink(link);
          if (webLink == null) {
            showAppDownloadModal();
            return;
          }

          // 외부/절대 URL은 location.href로 이동
          if (webLink.startsWith('http')) {
            if (link.startsWith('ably://webview')) {
              // ably webview 인 경우
              navigation.push('WebViewScreen', {
                url: webLink,
              });
              return;
            }
            location.href = webLink;
            return;
          }

          // TODO 나중엔 요걸 webCallback내부에서 하지 않고, bridge.openDeeplink 대신 호출하도록 수정함
          // 내부 경로: webRoutePaths에서 screen name 매칭 → RN 네비게이션
          const resolved = resolveScreenFromPath(webLink);
          if (resolved != null) {
            navigation.push(resolved.screen, {
              instanceId: `${resolved.screen}-${Date.now()}`,
              ...resolved.pathParams,
              ...resolved.queryParams,
            });
            return;
          }

          // 매칭 안 되면 fallback
          location.href = webLink;
        },
      });
    },
    [navigation, showAppDownloadModal],
  );

  return { openDeeplink };
};
